// project imports
import Loadable from 'components/Loadable';
import Tracker from 'components/Tracker';
import { GA_PAGE_VIEW_TYPE } from 'define';
import { Series } from 'pages/Series';
import { lazy } from 'react';

// ==============================|| MAIN ROUTING ||============================== //
const LandingPage = Loadable(lazy(() => import('pages/LandingPage')));
const Wallpaper = Loadable(lazy(() => import('pages/Wallpaper')));
const DownloadPage = Loadable(lazy(() => import('pages/DownloadPage')));
const SharePage = Loadable(lazy(() => import('pages/SharePage')));
const MainRoutes = [
    {
        path: '/',
        key: 'landing-page',
        exact: true,
        element: <LandingPage />
    },
    {
        path: '/wallpaper',
        key: 'wallpaper',
        exact: true,
        element: (
            <Tracker ga={GA_PAGE_VIEW_TYPE.view_wallpaper_page}>
                <Wallpaper />
            </Tracker>
        )
    },
    {
        path: '/wallpaper/:id',
        key: 'download-wallpaper',
        exact: true,
        element: (
            <Tracker ga={GA_PAGE_VIEW_TYPE.download_wallpaper} paramkey="id" formatter={(ga, value) => `${ga}/${value}`}>
                <DownloadPage />
            </Tracker>
        )
    },
    {
        path: '/series',
        key: 'series',
        exact: true,
        element: (
            <Tracker ga={GA_PAGE_VIEW_TYPE.view_wallpaper_series_page}>
                <Series />
            </Tracker>
        )
    },
    {
        path: '/share',
        key: 'share-wallpaper',
        exact: true,
        element: (
            <Tracker ga={GA_PAGE_VIEW_TYPE.share_wallpaper}>
                <SharePage />
            </Tracker>
        )
    },
    {
        path: '*',
        key: '404',
        element: <Wallpaper />
    }
];

export default MainRoutes;
